export const teaserI18n = Object.freeze({
  ratingDescription: 'rating',
});

export const alertsI18n = Object.freeze({
  mobileAlertsText: 'Follow',
  desktopAlertsText: 'Follow',
  alertsTextA11y: 'Get email notification for articles from ',
  podcastAllEpisodesText: 'All Episodes',
  podcastAllEpisodesUrl: 'https://www.haaretz.com/digital/podcast',
});

export const adsI18n = Object.freeze({
  adTitle: 'Advertisment',
});

export const seriesArticleI18n = Object.freeze({
  loadButton: Object.freeze({
    open: count => 'Load More',
    close: 'Close',
    ariaText: x => `${x} articles were added`,
  }),
  titlePrefix: 'Article series: ',
});

export const zoominText = 'zoom in';
export const zoomoutText = 'zoom out';

export const galleryI18n = Object.freeze({
  open: 'Open gallery view',
  captionPrefix: (current, total) => `${current} of ${total} | `,
  mobileList: total => `${total} Pictures`,
});

export const textInputI18n = Object.freeze({
  requiredLong: 'Required',
  requiredShort: '*',
});

export const tagsElementI18n = Object.freeze({
  prefix: 'Tags:',
});
export const topNewsI18n = Object.freeze({
  title: 'In The News:',
  externalId: 'com.hdc.content.TopNewsElement',
});

export const breadcrumbsI18n = Object.freeze({
  ariaLabel: 'Breadcrumb',
});

export const clickTrackerI18n = Object.freeze({
  promotedContentLabel: 'Promoted content',
});

export const creditPrefixI18n = Object.freeze({
  defaultCreditPrefix: 'Credit',
  imageCreditPrefix: 'Credit',
});

export const navigationMenuI18n = Object.freeze({
  buttonText: '',
  a11yTexts: Object.freeze({
    subMenu: (title, isOpen) => `${isOpen ? 'close' : 'open'} sub-menu ${title}`,
  }),
});

export const mobileNavigationMenuI18n = Object.freeze({
  buttonText: 'Navigate',
  close: 'Close menu',
  open: 'Open menu',
  home: 'Home',
  sectionsTitle: 'All Sections',
  siteName: 'Haaretz.com',
  more: 'More',
  back: 'Back',
  subscribe: Object.freeze({
    header: 'Read Unlimited',
    navBar: 'Subscribe',
  }),
  promotedLink: {
    href: 'https://www.haaretz.com/most',
    text: '10 Most read',
  },
});

export const mobileQuickRegistrationI18n = Object.freeze({
  signedUpText: 'Thank you for signing up',
});

export const headerSearchI18n = Object.freeze({
  buttonText: '',
  placeHolder: 'Type To Search',
  a11yTexts: Object.freeze({
    close: 'click to close search',
    execSearch: 'click to perform a search',
  }),
  queryUrl: query => `https://www.haaretz.com/misc/search-results?text=${query}&searchType=textSearch`,
  searchHistoryLabel: 'Latest Search',
  loadMore: 'Load more',
  noResultsText: 'No results found',
  foundResultsText: 'We found {__COUNT__} articles for search {__QUERY__}',
  resultsListTitle: 'Articles',
  resultsPageTitle: 'Haaretz - Search results',
  resultsForPageTitle: 'Haaretz - Search results for:',
});

export const recipesSearchI18n = Object.freeze({
  placeHolder: 'Search recipes here',
});

export const hotTopicsI18n = Object.freeze({
  label: 'Hot topics',
});

export const homepageLogoLink = Object.freeze({
  a11yText: 'Haaretz - back to home page',
});

export const mobileSearchI18n = Object.freeze({
  buttonText: 'Search',
  placeHolder: 'Type To Search',
  queryUrl: query => `https://www.haaretz.com/misc/mobile-search-results?text=${query}&searchType=textSearch`,
  searchHistoryLabel: 'Recent searches',
});

export const osakaI18n = Object.freeze({
  backToHome: 'Back to Home page',
  backToSection: 'Back to Section',
  nextArticle: 'Next Article',
  promotedContent: 'Promoted Content',
});

export const commentI18n = Object.freeze({
  tags: Object.freeze({
    editorsPick: 'בחירת העורכים',
    usersPick: 'בחירת הגולשים',
  }),
  buttons: Object.freeze({
    readMoreBtnTxt: 'Read more',
    replyBtnTxt: 'Reply',
    reportAbuseBtnTxt: 'Report',
    reportReceivedTxt: 'Report received',
    reportErrorTxt: 'Try again',
  }),
  ariaTexts: Object.freeze({
    subCommentTxt: 'Reply to comment',
  }),
  tooltip: Object.freeze({
    ratedUserText: rating => `דירוג: ${rating}. הדירוג (בסולם של 1-100) מתבסס על איכות התכנים, מספר הלייקים והתגובות שקיבלו. מנויים שמעוניינים להיכנס לדירוג צריכים לבחור כינוי קבוע`,
    verifiedUserText: 'אומת ע״י המערכת',
  }),
});

export const commentFormI18n = Object.freeze({
  nickName: Object.freeze({
    or: ' or ',
  }),
  buttons: Object.freeze({
    sendBtnTxt: 'Send',
    cancelBtnTxt: 'Cancel',
    toggleUserBtnText: identified => (identified ? 'Add anonymous comment' : 'Add identified comment'),
    haaretzSheliUrl: 'https://www.haaretz.co.il/personal-area/haaretz-sheli?shownickname',
    addUserNickName: 'Get a nickname',
    nonPayingNickNamePromotionBtn: 'I want a nickname',
    promotionUrl: buttonText => `https://promotions.haaretz.co.il/promotions-page?htm_source=site&htm_medium=Talkbacks&htm_campaign=Nickname_Promotion&htm_content=${buttonText}`,
    nonPayingNickNameNoThanks: 'No thanks',
    nickNameChangeNowTxt: 'Change now',
    cancelNickName: 'Cancel',
    retrySetNicknameTxt: 'Try again',
    confirmSetNickname: 'Update',
    cancelSetNickname: 'Cancel',
  }),
  labels: Object.freeze({
    nameLabelTxt: 'Name',
    commentLabelTxt: 'Comment',
  }),
  notes: Object.freeze({
    nameNoteTxt: 'Enter the commenter display name',
    commentNoteTxt: 'By adding a comment, I agree to this site’s Terms of use',
  }),
  errorNotes: Object.freeze({
    nameErrorNoteTxt: 'Name is required',
    commentErrorNoteTxt: 'Comment is required',
    commentErrorTooLongNoteTxt: 'Comment max length is 1,000 chars',
  }),
  texts: Object.freeze({
    nonPayingNickNameAlertText:
      'Digital subscribers can choose a permanent nickname, get stars, and enjoy quick responses',
  }),
});
export const commentSentI18n = Object.freeze({
  buttons: Object.freeze({
    getNotificationsBtnTxt: 'Keep me posted',
    dontGetNotificationsBtnTxt: 'No thanks',
    closeBtnText: 'Close',
    goBackBtnText: 'Back',
  }),
  labels: Object.freeze({
    emailLabelTxt: 'Email',
  }),
  notes: Object.freeze({
    emailNoteTxt: 'Please enter a valid email address',
  }),
  errorNotes: Object.freeze({
    emailErrorNoteTxt: 'Please enter a valid email address',
  }),
  texts: Object.freeze({
    commentRecievedBoldText: 'Thank you!',
    commentRecievedText: '',
    commentRecievedTextSecondRow:
      'Your comment was successfully submitted and will be published in accordance with site policy. If you would like to be notified when your comment is published, please fill in your email address in the form below.',
    commentRecievedBoldTextThankYouPage: 'Thank You!',
    commentRecievedTextThankYouPage:
      'Your comment was successfully submitted and will be published in accordance with site policy.',
    commentDidNotRecieved: 'Something went wrong an your comment was not submitted to our site',
    tryAgainText: 'Try again?',
  }),
});
export const commentsSectionI18n = Object.freeze({
  signin: {
    signin: 'Sign in',
    text: 'to join the conversation.',
  },
  buttons: Object.freeze({
    loadMoreCommentsBtnText: 'More comments',
  }),
  selectItems: Object.freeze({
    dateDescendingItemTxt: 'Oldest first',
    dateAscendingItemTxt: 'Newest first',
    commentRatingItemTxt: 'Top-rated first',
    editorsPickItemTxt: 'Editors choice',
  }),
  texts: Object.freeze({
    chooseSortMethodText: 'Sort comment by',
  }),
  likes: Object.freeze({
    like: 'like',
    dislike: 'dislike',
  }),
});

export const commentsCountI18n = Object.freeze({
  countSuffix: 'comment to article ',
});

export const podcastI18n = Object.freeze({
  includePodcast: 'Article conatains podcast',
  rssLinkText: 'Sign up for podcast',
});

export const commercialListI18n = Object.freeze({ text: 'שיתופי פעולה', });

export const errorPageI18n = Object.freeze({
  error404: Object.freeze({
    headline: 'נראה שהלכת לאיבוד',
    paragraph: 'אפשר ליהנות מהשקט או לחזור למציאות',
    button: Object.freeze({
      text: 'Back to home-page',
      href: 'https://www.haaretz.com',
    }),
  }),
});

export const footerMobileListsI18n = Object.freeze({
  MobileList: [
    Object.freeze({
      text: 'Subscribe',
      link: 'https://www.haaretz.com/promotions-page',
    }),
    Object.freeze({
      text: 'Newletters',
      link: 'https://www.haaretz.com/misc/newsletters-page',
    }),
    Object.freeze({
      text: 'Terms',
      link: 'https://www.haaretz.com/misc/terms-of-use',
    }),
    Object.freeze({
      text: 'Contact Us',
      link: 'https://www.haaretz.com/mobile/contact-us',
    }),
    Object.freeze({
      text: 'FAQ',
      link: 'https://www.haaretz.com/misc/faq',
    }),
    Object.freeze({
      text: 'Advertize',
      link: 'https://www.haaretz.com/st/c/prod/global/mediaKit/haaretzCom.html',
    }),
  ],
  ButtonName: Object.freeze({
    text: 'Dowload App',
    androidAppUrl: 'https://play.google.com/store/apps/details?id=com.opentech.haaretz&hl=en',
    iosAppUrl: 'https://itunes.apple.com/il/app/haaretz-english-edition/id504537897?mt=8',
  }),
  Copyright: Object.freeze({
    text: '© Haaretz Daily Newspaper Ltd. All Rights Reserve',
  }),
});

export const footerDesktopI18n = Object.freeze({
  ExpandedButton: Object.freeze({
    close: 'Close',
    showMore: 'Load more',
  }),
  Copyright: Object.freeze({
    firstRow:
      'Haaretz.com, the online edition of Haaretz Newspaper in Israel, and analysis from Israel and the Middle East',
    secondRow: '© Haaretz Daily Newspaper Ltd. All Rights Reserve',
  }),
});

export const footerSocialLinksI18n = Object.freeze({
  facebook: 'https://www.facebook.com/haaretzcom',
  twitter: 'https://twitter.com/haaretzcom',
  androidApp: 'https://play.google.com/store/apps/details?id=com.opentech.haaretz',
  appleApp: 'https://apps.apple.com/us/app/haaretz-english-edition/id504537897',
  redmail: 'https://www.haaretz.com/misc/newsletters-page',
  rss: 'https://www.haaretz.com/misc/subscribe-to-rss-feed',
});

export const newsletterI18n = Object.freeze({
  input: Object.freeze({
    emptyEmailError: 'Please insert a your Email address',
    invalidEmailError: 'Please insert a valid Email address',
  }),
  buttons: Object.freeze({
    signUp: 'Sign Up',
    newsletterConfirmedButton: Object.freeze({
      ok: 'Click here',
      alreadyRegister: 'Sign up for more newsletters',
      failed: 'Try again',
    }),
  }),
  newsletterForm: Object.freeze({
    noteText: 'Please insert a valid Email address',
    labelText: 'Email',
  }),
  texts: Object.freeze({
    newsletterConfirmedTitleText: Object.freeze({
      ok: 'Thank you for signing up',
      alreadyRegister: 'You are already signed up',
      failed: 'Excuse us, there was a error while signing up',
    }),
    newsletterConfirmedText: Object.freeze({
      ok: 'We’ve got more newsletters we think you’ll find interesting',
      alreadyRegister: 'This email is already signed up for this newsletter',
      failed: 'Please try again later',
    }),
    defaultTitleText: 'Breaking news and analyses straight to your inbox',
  }),
});

export const fryListI18n = Object.freeze({
  title: 'מרחבי הרשת',
});

export const welcomePageI18n = Object.freeze({
  texts: Object.freeze({
    headerHighLighted: 'ברוכים הבאים',
    headerNormal: 'לחוויה המשודרגת של הארץ',
    bullets: [
      'מהיר יותר',
      'נוח לקריאה',
      'מותאם יותר למובייל',
      'פחות פרסומות',
      'ממשק תגובות משופר',
      'קל ומהיר יותר לשתף',
    ],
  }),
  buttonText: 'לעמוד החדש',
});

export const userMenuI18n = Object.freeze({
  buttonText: 'Hi',
  loginUrl: 'https://www.haaretz.com/misc/login-page',
  logout: 'log out',
  menuPos: Object.freeze({
    start: 'unset',
    end: '0',
  }),
  menuItems: Object.freeze([
    Object.freeze({
      name: 'settings',
      biActionCode: 129,
      url: 'https://www.haaretz.com/personal-area/my-account',
    }),
    Object.freeze({
      name: 'subscribers services',
      biActionCode: 130,
      url: 'https://www.haaretz.com/personal-area/my-account',
    }),
    Object.freeze({
      name: 'newletters',
      biActionCode: 131,
      url: 'https://www.haaretz.com/personal-area/newsletter',
    }),
  ]),
  noUserData: 'LOG IN',
});

export const a11yMenuI18n = Object.freeze({
  a11yToggle: state => `${state ? 'Stop' : 'Start'} contrast`,
  a11yTitle: 'accessibility',
  cancelRefresh: 'Prevent auto-refresh',
  menuItems: Object.freeze([
    Object.freeze({
      name: 'Report an accessibility issue',
      url: 'mailto:accessibility@haaretz.com',
    }),
    Object.freeze({
      name: 'Accessibility manifest',
      url: 'https://www.haaretz.com/misc/accessibility',
    }),
  ]),
});

export const zenTextI18n = 'Zen Read';

export const readingListMenuI18n = Object.freeze({
  url: 'https://www.haaretz.com/personal-area/my-account#readingList',
  a11yText: 'מעבר לרשימת הקריאה',
});

export const mastheadSubscriptionI18n = Object.freeze({
  url:
    'https://promotions.haaretz.com/promotions-page?htm_source=site&htm_medium=button&htm_campaign=subscription&htm_campaign_type=subscription&htm_content=hello_default',
  text: 'SUBSCRIBE NOW',
  a11yText: 'Subscribe now',
});

export const serviceByMailI18n = Object.freeze({
  alertType: articleType => (articleType === 'blogArticle' ? 'blogers_hdc' : 'writers_eng'),

  authorAlertServiceTitle: 'Send me email alerts for new articles by ',
  inpEmailLabelText: 'Email',
  inpEmailNoteText: 'Please insert a valid Email address',
  btnSubmitText: 'Send',
  btnCancelText: 'Cancel',
  btnCloseText: 'Close',
  btnMoreNewsLettersHref: 'http://www.haaretz.com/misc/newsletters-page',
  btnMoreNewsLettersText: 'Click Here',

  inpEmailErrorRequired: 'Please insert a Email address',
  inpEmailErrorInvalid: 'Please insert a valid Email address',

  successDefaultMessage: name => `You are now following ${name} by email alert.`,
  successDefaultMessageSecondRow: 'For a list of Haaretz newsletters',
  failureDefaultMessage: 'Registration failed, please try again later',
});

export const mobileAdditionalShare = Object.freeze({
  text: 'Share',
});

export const shareBarI18n = Object.freeze({
  linkToComments: 'Go to comments',
  facebookToolTip: 'Share in Facebook',
  fbMessengerToolTip: 'Share in Messenger',
  emailToolTip: 'Send in e-mail',
  printToolTip: 'Print article',
  twitterToolTip: 'Share in Twitter',
  whatsappToolTip: 'Share in WhatsApp',
  redditTooltip: 'Share in Reddit',
  googlePlusTooltip: 'Share in G+',
  telegramPlusTooltip: 'Share in Telegram',
  commentsPlusTooltip: 'Go to comments',
  mobileChangingShareButton: 'reddit',
  shareButtons: ({ theme, isMouseStory, }) => ({
    startButtons: [
      {
        name: 'facebookLogo',
        buttonStyles: {
          color: theme.color('facebook'),
          ':hover': {
            color: theme.color('facebook'),
          },
        },
      },
      {
        name: 'twitter',
        buttonStyles: {
          color: theme.color('twitter'),
          ':hover': {
            color: theme.color('twitter'),
          },
        },
      },
      {
        name: 'reddit',
        buttonStyles: {
          color: theme.color('reddit'),
          ':hover': {
            color: theme.color('reddit'),
          },
        },
      },
      {
        name: 'mail',
        buttonStyles: {
          color: theme.color('shareBar', 'button'),
          ':hover': {
            color: theme.color('shareBar', 'buttonHover'),
          },
        },
      },
    ],
    endButtons: [ 'zen', 'print', ],
  }),
  magazineShareButtons: ({ theme, isPhotoBlog, }) => ([
    {
      name: 'facebook',
      buttonStyles: {
        color: isPhotoBlog ? theme.color('bodyText', 'inverse') : theme.color('facebook'),
        ':hover': {
          color: isPhotoBlog ? theme.color('quaternary') : theme.color('facebook'),
        },
      },
    },
    {
      name: 'twitter',
      buttonStyles: {
        color: theme.color('twitter'),
        ':hover': {
          color: theme.color('twitter'),
        },
      },
    },
    {
      name: 'reddit',
      buttonStyles: {
        color: theme.color('reddit'),
        ':hover': {
          color: theme.color('reddit'),
        },
      },
    },
    'mail',
    { name: 'comments', textMiscStyles: { display: 'none', }, },
    'print',
    {
      name: 'zen',
      buttonText: theme.zenTextI18n,
      iconStyles: {
        color: theme.color('magazine', 'shareBarZen'),
      },
    },
  ]),
  emailSubjectSuffix: '- Haaretz.com',
});

export const mobileUserMenuI18n = Object.freeze({
  noUserData: 'Log in',
  userLoggedIn: 'Log out',
  url: 'https://www.haaretz.com/mobile/login',
});

export const readingListUpdateI18n = Object.freeze({
  a11y: Object.freeze({
    add: 'Add article to reading list',
    subtract: 'Remove article from reading list',
  }),
  add: 'Add',
  subtract: 'Remove',
});

export const selectAriaLabel = Object.freeze({
  text: 'sort comments',
});
export const recipeInstructionsI18n = Object.freeze({
  sectionTitle: 'Instructions',
});
export const recipeTipsI18n = Object.freeze({
  sectionTitle: 'Tips',
});
export const recipeIngredientsI18n = Object.freeze({
  sectionTitle: 'Ingredients',
});

export const recipeRatingI18n = Object.freeze({
  levelText: Object.freeze({
    easy: 'Easy',
    medium: 'Medium',
    hard: 'Advanced',
  }),
  highlightedText: Object.freeze({
    level: 'דרגת קושי',
    portions: 'מנות',
    time: 'זמן בישול',
  }),
  ratingTitle: 'דירוג הגולשים',
});

export const reviewRatingI18n = Object.freeze({
  ratingTitle: 'דירוג',
});

export const ratingI18n = Object.freeze({
  a11yTexts: Object.freeze({
    rateAction: rate => `לחץ כדי לדרג ב-${rate} כוכבים`,
    rating: rating => `${rating} כוכבים`,
  }),
});

export const liveBlogI18n = Object.freeze({
  liveUpdate: 'LIVE',
  updatesTitle: 'עדכונים',
  firstToLastLabel: 'סדר מהראשון לאחרון',
  lastToFirstLabel: 'סדר מהאחרון לראשון',
  expand: 'להרחבה',
  close: 'סגור',
});

export const articleLayoutI18n = Object.freeze({
  commentSectionTitle: 'Comments',
});

export const breakingNewsStrip = Object.freeze({
  url: 'https://www.haaretz.com/misc/breaking-news',
  title: 'מבזקים',
  pause: 'עצור',
  play: 'הפעל',
  toPrevItem: 'למבזק קודם',
  toNextItem: 'למבזק הבא',
  externalId: 'Haaretz.Element.BreakingNewsBoxElement',
});

export const dayMap = Object.freeze({
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wendsday',
  4: 'Thuuuuuuuuuuuuuuuuuuuuuursday',
  5: 'Friday',
  6: 'Saturday',
});

export const marketingTools = Object.freeze({
  EmailConfirmation: {
    buttonText: 'Clickk here',
    buttonTextAfterClick: 'Thank you',
    text1: 'זה באמת אתם?',
    text2: 'כדי לקרוא בחינם 6 כתבות בחודש יש לבצע אימות',
    text2AfterClick: 'יש לאשר את ההודעה מתוך תיבת האימייל שלך',
  },
  Weekly: {
    buttonText: 'לפרטים נוספים',
    text1: 'כל תכני הארץ בכל מכשיר בכל זמן',
    text2: 'פחות פרסומות ובאנרים',
    weeklyLink: '',
    url:
      'https://promotions.haaretz.com/promotions-page/product?offer=sale-hdc&_ga=2.36776032.1903070321.1547973707-1620996918.1546958670',
  },
});

export const footballHeaders = Object.freeze({
  headers: [ 'קבוצה', "מש'", "נצ'", "תי'", "הפ'", 'הפרש', "נק'", ],
});

export const groupBarTabs = Object.freeze({
  headers: [ 'בית 1', 'בית 2', 'בית 3', 'בית 4', 'בית 5', 'בית 6', 'בית 7', 'בית 8', ],
});

export const nbaHeaders = Object.freeze({
  desktop: [ 'קבוצה', 'ניצחונות', 'הפסדים', 'אחוז', ],
  mobile: [ 'קבוצה', "נצ'", "הפ'", 'אחוז', ],
});

export const btnOptions = Object.freeze({
  title: {
    open: 'הסתר',
    close: 'טען עוד',
  },
  degree: {
    open: 90,
    close: 270,
  },
});

export const coastHeaders = Object.freeze({
  east: 'מזרח',
  west: 'מערב',
});

export const survey = Object.freeze({
  button: 'לכל הסקרים',
});

export const surveyPie = Object.freeze({
  title: 'מפת הגושים',
  redLegend: 'ימין ודתיים',
  blueLegend: 'שמאל, מרכז וערבים',
});

export const greetingsI18n = Object.freeze({
  morning: 'Good Morning',
  noon: 'Good Day',
  afternoon: 'Good Day',
  evening: 'Good Evening',
  night: 'Good Night',
  default: 'Hi',
});

export const universityTitlesI18n = Object.freeze({
  1111111111: 'אוניברסיטת ת"א',
  11111111111: 'אוניברסיטת ת"א',
  1212121212: 'אוניברסיטת ב"ג',
  2121212121: 'בר-אילן',
  2321232143: 'אוניברסיטת אריאל',
  101015: 'המכללה למנהל',
  8.366817631: 'האוניברסיטה הפתוחה',
});

export const timeLabels = Object.freeze({
  pubDateAtText: 'Published at ',
  pubDateOnText: 'Published on ',
  modDateAtText: 'Modified at ',
  modDatOneText: 'Modified on ',
  sameDayTimeFormat: 'HH:mm',
  timeFormat: 'MM.DD.YY',
});

export const zenNonPayingUsers = Object.freeze({
  title: 'Want to enjoy \'Zen\' reading'.toUpperCase(),
  subTitle: 'with no ads and just the article?<br/>Subscribe today'.toUpperCase(),
  button: 'Subscribe'.toUpperCase(),
  buttonUrl: 'https://promotions.haaretz.com/promotions-page/product',
});

export const adBlockPage = Object.freeze({
  title1a: 'Haaretz.com is now inaccessible',
  title1b: 'to visitors using ad blockers',
  text1: `In order to provide our readers with the best news, commentary and analyses from Israel,
              the Middle East and the U.S., we employ hundreds of reporters, editors, photographers, developers, designers and other media professionals.
              Income from subscriptions and advertising allows us to continue developing the website.`,
  title2: 'How to access the site:',
  text2: 'Subscribers enjoy full access to all Haaretz.com content on all platforms - as well as fewer ads - for just $1 for the first month.',
  button: 'Subscribe',
  buttonUrl: 'https://promotions.haaretz.com/promotions-page/product',
  loginText: 'Already subscribed?',
  loginUrl: 'https://www.haaretz.com/misc/login-page',
  loginUrlText: 'Log in',
  instructionsTitle: 'Whitelist Haaretz.com in your ad blocker',
  instructionsList: [
    'Click the Ad Blocker extension at the top of your browser:',
    'Click “Pause on this site”:',
    'to view all Haaretz.com content or Refresh the page.',
  ],
  instructionsListImages: [
    '/static/hdc/images/adb-step-1.png',
    '/static/hdc/images/adb-step-2.png',
    null,
  ],
});

export const tateI18n = Object.freeze({
  loadMoreBtn: 'עוד כתבות',
});

export const audioPlayerI18n = Object.freeze({
  ariaValueText: (currentValue, totalValue) => `${currentValue} מתוך ${totalValue}`,
  play: 'לחצו כדי לנגן',
  pause: 'לחצו כדי להשהות את הניגון',
  changeRate: (from, to) => `לחצו כדי לשנות את מהירות הניגון מ-${from} ל-${to}`,
  skip: by => `דלגו ${Math.abs(by)} שניות ${by < 0 ? 'אחורה' : 'קדימה'}`,
});
export const podcastChannelTitle = 'You can hear and register to podcasts with:';

export const podcastChannelNames = {
  application: 'Haaretz app',
  apple: 'Apple',
  spotify: 'Spotify',
  google: 'Google',
};

export function tldrDefaultContent(tldrWordCount) {
  const finalTldrWordCount = tldrWordCount != null && tldrWordCount !== 0 ? tldrWordCount : 100;
  return Object.freeze({
    cookie: 'Hdc',
    titleRegular: 'Would you like us to summarize articles for you?',
    titlePusr: `Article summary in ${finalTldrWordCount} words`,
    titleDefault: 'Article summary up to 100 words',
    text: 'Subscribe now to Haaretz.com to enjoy unlimited access and special services, available to subscribers only',
    purchaseButton: 'Subscribe Now',
  });
}

export const tldrPromotionLink = '/promotions-page?htm_source=site&htm_medium=button&htm_campaign=TLDR?htm_content';

export const seoI18n = Object.freeze({
  titlePrefix: ' - Haaretz',
});

export const promotionsI18n = Object.freeze({
  baseUrl: 'https://promotions.haaretz.com',
});

export const paywallI18n = Object.freeze({
  sendMailConfirmationSite: 'hdc',
  sendMailConfirmationType: 'HDC_MAIL_VALIDATION',
});

export const magazineExclusivesI18n = Object.freeze({
  photoBlog: Object.freeze({}),
  faceAffairs: Object.freeze({}),
});

export const pushwooshCustomPopup = Object.freeze({
  text: 'Haaretz wants to send you breaking news updates. <br/> Get only the most important updates and interesting reads',
  askLaterButtonText: 'Another time',
  confirmSubscriptionButtonText: 'Sounds good',
});

export const words = Object.freeze({
  and: 'and ',
});
